import { useState, useLayoutEffect } from "react";

export function useIsPointerCoarse(query = "(pointer: coarse)") {
    const [matches, setMatches] = useState(false);

    useLayoutEffect(() => {
        const mediaQuery = window.matchMedia(query);
        setMatches(mediaQuery.matches);

        mediaQuery.onchange = (event) => {
            setMatches(event.matches);
        };

        return () => {
            mediaQuery.onchange = null;
        };
    }, [query]);

    return matches;
}
